export function floorMinute(d: Date) {
    if ((d.getSeconds() === 0) && (d.getMilliseconds() === 0)) {
        return d;
    }
    return new Date(
        new Date(
            d.getFullYear(),
            d.getMonth(),
            d.getDate(),
            d.getHours(),
            d.getMinutes(),
            0,
            0,
        ),
    );
}

export function ceilMinute(d: Date) {
    if ((d.getSeconds() === 0) && (d.getMilliseconds() === 0)) {
        return d;
    }
    return new Date(
        new Date(
            d.getFullYear(),
            d.getMonth(),
            d.getDate(),
            d.getHours(),
            d.getMinutes(),
            0,
            0,
        ).getTime() + 60000,
    );
}

export function dateFromProto(val: number | any): Date {
    if (!(typeof val === 'number')) {
        if (
            (val.toNumber() === 0) ||
            (val.compare(-8640000000000) === -1) ||
            (val.compare(8640000000000) === 1)
        ) {
            throw new Error('Invalid date');
        }
        return new Date(val.toNumber() * 1000);
    }
    return new Date(val * 1000);
}

export function getDateTodayHourZero() {
    let date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
}

export function getDateSevenDaysBeforeTodayHourZero(todayHourZero: Date) {
    let date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), todayHourZero.getDate() - 6, 0, 0, 0);
}
export function getDateHourZero(date: Date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}
export function getDateOneDayBeforeTodayHourZero(todayHourZero: Date) {
    let date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), todayHourZero.getDate() - 1, 0, 0, 0, 0);
}
export function adjustForTimezone(date: Date): Date {
    var timeOffsetInMS: number = date.getTimezoneOffset() * 60000;

    return new Date(date.getTime() - timeOffsetInMS);
}
export function fromUTC(date: Date) {
    var timeOffsetInMS: number = date.getTimezoneOffset() * 60000;

    return new Date(date.getTime() + timeOffsetInMS);
}

export function addZeroBefore(num: number) {
    return (num < 10 ? '0' : '') + num;
}

export function dateDiff(date1: any, date2: any) {
    let diff = {
        sec: 0,
        min: 0,
        hour: 0,
        day: 0
    };                                      // Initialisation du retour
    let tmp = date2 - date1;

    tmp = Math.floor(tmp / 1000);             // Nombre de secondes entre les 2 dates
    diff.sec = tmp % 60;                    // Extraction du nombre de secondes

    tmp = Math.floor((tmp - diff.sec) / 60);    // Nombre de minutes (partie entière)
    diff.min = tmp % 60;                    // Extraction du nombre de minutes

    tmp = Math.floor((tmp - diff.min) / 60);    // Nombre d'heures (entières)
    diff.hour = tmp % 24;                   // Extraction du nombre d'heures

    tmp = Math.floor((tmp - diff.hour) / 24);   // Nombre de jours restants
    diff.day = tmp;

    return diff;
}
export function secondsToHMS(seconds: number) {
    var h = Math.floor(seconds / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);

    return addZeroBefore(h) + ':' + addZeroBefore(m) + ':' + addZeroBefore(s);
}

export function fromDateToTimestamp(d: string) {
    let date = new Date(d)
    return date.setHours(date.getHours() + 2)
}

function pad(s: number) { return (s < 10) ? '0' + s : s; }

export function convertDate(inputFormat: string) {
    var d = new Date(inputFormat)
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/')
}

export function convertToTime(inputFormat: string) {
    var d = new Date(inputFormat)
    return [pad(d.getHours()), pad(d.getMinutes())].join(':')
}

export function convertToDayMonth(inputFormat: string) {
    var d = new Date(inputFormat)
    return [d.getDate(), d.getMonth() + 1].join('/')
}
export function convertToDayMonthYear(inputFormat: string) {
    var d = new Date(inputFormat)
    return [d.getDate(), d.getMonth() + 1, d.getFullYear()].join('/')
}
export function minMaxDates(xdates: Date[]) {
    let dates: any[] = []
    xdates.map(d => dates.push(d))
    const maxDate = new Date(Math.max.apply(null, dates));
    const minDate = new Date(Math.min.apply(null, dates));
    return {
        maxDate: maxDate,
        minDate: minDate
    }
}
export function diff_minutes(dt2: Date, dt1: Date) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    let minutes = Math.abs(Math.round(diff));
    return minutes
}

export function ensureEndAfterStartDay(start: Date, end: Date): Date {
    const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0, 0);
    const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 0, 0, 0, 0);
    if (startDay.getTime() === endDay.getTime()) {
        return new Date(end.getFullYear(), end.getMonth(), end.getDate() + 1, end.getHours(), end.getMinutes(), end.getSeconds(), end.getMilliseconds());
    }
    return end;
}
